import { NgModule } from "@angular/core";
import { StorybookComponent } from "./storybook.component";
import { CommonModule } from "@angular/common";
import { Route, RouterModule } from "@angular/router";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { ButtonsStorybookComponent } from "./buttons/buttons-storybook.component";
import { ButtonToggleStorybookComponent } from "./button-toggle/button-toggle-storybook.component";
import { MatButtonToggle, MatButtonToggleGroup } from "@angular/material/button-toggle";
import { ButtonWrapperComponent } from "../button-wrapper/button-wrapper.component";
import { AvatarStorybookComponent } from "./avatar/avatar-storybook.component";
import { AvatarComponent } from "../avatar/avatar.component";
import { DropdownStorybookComponent } from "./dropdown/dropdown-storybook.component";
import { FormFieldStorybookComponent } from "./form-field/form-field-storybook.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { ReactiveFormsModule } from "@angular/forms";
import { ChipStorybookComponent } from "./chip/chip-storybook.component";
import { MatChipsModule } from "@angular/material/chips";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { IconsModule } from "../icons/icons.module";
import { MatRadioModule } from "@angular/material/radio";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { ProgressBarComponent } from "../progress-bar/progress-bar.component";
import { ProgressStorybookComponent } from "./progress/progress-storybook.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ProgressSpinnerComponent } from "../progress-spinner/progress-spinner.component";
import { MatTabsModule } from "@angular/material/tabs";
import { AlertStorybookComponent } from "./alert/alert-storybook.component";
import { FuseAlertModule } from "../alert";
import { MatPaginatorModule } from "@angular/material/paginator";
import { PaginatorStoryBookComponent } from "./paginator/paginator-storybook.component";
import { DatePickerStorybookComponent } from "./datepicker/datepicker-storybook.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { VuiDatepickerModule } from "../datepicker/vui-datepicker.module";

const routes: Route[] = [
    {
        component: StorybookComponent,
        path: "",
    },
];

@NgModule({
    declarations: [
        StorybookComponent,
        ButtonsStorybookComponent,
        ButtonToggleStorybookComponent,
        AvatarStorybookComponent,
        FormFieldStorybookComponent,
        ChipStorybookComponent,
        ProgressStorybookComponent,
        AlertStorybookComponent,
        PaginatorStoryBookComponent,
        DatePickerStorybookComponent,
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        ReactiveFormsModule,
        MatTabsModule,
        MatIconModule,
        MatButtonModule,
        MatButtonToggle,
        MatButtonToggleGroup,
        ButtonWrapperComponent,
        AvatarComponent,
        DropdownStorybookComponent,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatChipsModule,
        MatSlideToggleModule,
        IconsModule,
        MatRadioModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,

        ProgressBarComponent,
        ProgressSpinnerComponent,
        IconsModule,
        FuseAlertModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatDatepickerModule,
        VuiDatepickerModule,
    ],
    schemas: [],
})
export class StoryBookModule {}
